<form [formGroup]="form">
  <div class="row mb-3">
    <div class="col">
      <p>
        Se establecerá una nueva contraseña para el usuario
        <span class="user-name">{{ user }}</span>
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <kendo-formfield>
        <kendo-label text="Nueva contraseña">
          <input type="password" kendoTextBox formControlName="password" />
        </kendo-label>
        <kendo-formerror *ngIf="form.get('email')?.errors?.['required']">
          Contraseña es requerida
        </kendo-formerror>
      </kendo-formfield>
    </div>
  </div>
  <kendo-dialog-actions layout="end">
    <button (click)="closeDialog()" kendoButton>
      {{ "BUTTON.CANCEL_LABEL" | translate }}
    </button>
    <button (click)="send()" kendoButton themeColor="primary">CONFIRMAR</button>
  </kendo-dialog-actions>
</form>
